import { Context } from './context'
import { throwObjectNotFound } from './errors'
import { formatString, getObjectKeys, runIfDefined } from './tools'
import { Translatable, TranslationGetter } from './translatable'
import { isString } from './typeChecking'

export interface TranslationService<DictType> {
  tr(ctx: Context, translatable: Translatable<DictType>, ...args: unknown[]): string
  tr(langCode: string | undefined, translatable: Translatable<DictType>, ...args: unknown[]): string
  translate(langCode: string | undefined, getter: TranslationGetter<DictType>, ...args: unknown[]): string
  translate(ctx: Context, getter: TranslationGetter<DictType>, ...args: unknown[]): string
}

interface DictTranslationServiceOpts<DictType> {
  dicts: { [langCode: string]: DictType }
  fallbackLangCode?: string
}

export class DictTranslationService<DictType> implements TranslationService<DictType> {
  constructor(private opts: DictTranslationServiceOpts<DictType>) {}

  tr(langCodeOrCtx: string | Context | undefined, translatable: Translatable<DictType>, ...args: unknown[]): string {
    return this.translate(langCodeOrCtx, translatable.getter, ...(args.length > 0 ? args : translatable.args))
  }

  translate(
    langCodeOrCtx: string | Context | undefined,
    getter: TranslationGetter<DictType>,
    ...args: unknown[]
  ): string {
    let langCode: string | undefined
    if (isString(langCodeOrCtx)) {
      langCode = langCodeOrCtx
    } else {
      langCode = langCodeOrCtx?.langCode
    }
    const dict =
      (langCode ? this.opts.dicts[langCode] : undefined) ??
      runIfDefined(this.opts.fallbackLangCode, code => this.opts.dicts[code]) ??
      this.opts.dicts[getObjectKeys(this.opts.dicts)[0]] ??
      throwObjectNotFound(`<0c37bf3f> Dictionary for langCode=${langCode} not found`)
    const text = getter(dict)
    return formatString(text, ...args)
  }
}
